module.exports = __webpack_public_path__ + "static/media/mongodb.d416519f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/mongodb.png
// module id = 149
// module chunks = 0